/**
 * Máscaras de formatação para campos de formulário
 * Agendario Admin - Utils
 */

/**
 * Formata telefone brasileiro
 * @param {string} value - Valor do input
 * @returns {string} - Telefone formatado (99) 99999-9999
 */
export const phoneMask = (value) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1');
};

/**
 * Formata CPF brasileiro
 * @param {string} value - Valor do input
 * @returns {string} - CPF formatado 999.999.999-99
 */
export const cpfMask = (value) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

/**
 * Formata CEP brasileiro
 * @param {string} value - Valor do input
 * @returns {string} - CEP formatado 99999-999
 */
export const cepMask = (value) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
};

/**
 * Formata moeda brasileira (R$)
 * @param {string|number} value - Valor a ser formatado
 * @returns {string} - Moeda formatada R$ 1.234,56
 */
export const currencyMask = (value) => {
  const numericValue = typeof value === 'string' ? value.replace(/\D/g, '') : String(value);
  const floatValue = parseFloat(numericValue) / 100;
  
  return floatValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

/**
 * Remove máscara de telefone (retorna apenas dígitos)
 * @param {string} value - Telefone formatado
 * @returns {string} - Apenas dígitos
 */
export const unmaskPhone = (value) => {
  return value.replace(/\D/g, '');
};

/**
 * Remove máscara de CPF (retorna apenas dígitos)
 * @param {string} value - CPF formatado
 * @returns {string} - Apenas dígitos
 */
export const unmaskCpf = (value) => {
  return value.replace(/\D/g, '');
};

/**
 * Remove máscara de CEP (retorna apenas dígitos)
 * @param {string} value - CEP formatado
 * @returns {string} - Apenas dígitos
 */
export const unmaskCep = (value) => {
  return value.replace(/\D/g, '');
};

/**
 * Valida CPF brasileiro
 * @param {string} cpf - CPF a ser validado
 * @returns {boolean} - true se válido, false caso contrário
 */
export const validateCpf = (cpf) => {
  const cleanCpf = unmaskCpf(cpf);
  
  if (cleanCpf.length !== 11 || /^(\d)\1{10}$/.test(cleanCpf)) {
    return false;
  }

  let sum = 0;
  let remainder;

  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cleanCpf.substring(i - 1, i)) * (11 - i);
  }

  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cleanCpf.substring(9, 10))) return false;

  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cleanCpf.substring(i - 1, i)) * (12 - i);
  }

  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cleanCpf.substring(10, 11))) return false;

  return true;
};
